import React from 'react'
import EloImg from '../../../assets/icons/elo-icon.png'
import EloImgPb from '../../../assets/icons/elo-icon-pb.png'
import { StyledIcon } from './styled-icon.style'

/**
 * @param {boolean} disabled
 * if true, set the img to black and white
 */
const EloIcon = ({ disabled, className }) => (
	<StyledIcon className={className}>
		<img src={disabled ? EloImgPb : EloImg} alt="Ícone Elo" />
	</StyledIcon>
)

export default EloIcon
